import axiosHttp from "services/axiosHttp";
const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

//action
export const fetchContentBannersList = createAsyncThunk("fetchContentBannersList", async (language = "en") => {
	const response = await axiosHttp.get(`vision/content-banners?lang=${language}`);
	return response.data.data;
});

const ContentBannersSlice = createSlice({
	name: "ContentBannersSlice",
	initialState: {
		isLoading: false,
		data: null,
		error: null,
	},

	extraReducers: (builder) => {
		builder.addCase(fetchContentBannersList.pending, (state) => {
			state.isLoading = true;
		});

		builder.addCase(fetchContentBannersList.fulfilled, (state, action) => {
			state.isLoading = false;
			state.data = action.payload;
		});
		builder.addCase(fetchContentBannersList.rejected, (state, action) => {
			state.isLoading = false;
			state.error = action.payload;
		});
	},
});

export default ContentBannersSlice.reducer;
